import { useCallback, useEffect } from 'react';
import { usePublishDraftJobPost } from '~/domain/PermanentJobs';
import { showErrorMessage } from '~/domain/utils';

interface IUsePublishJobPostPayload {
  jobPostingId?: string;
  planId?: string;
  onSuccess?: () => void;
}

export const usePublishJobPost = ({
  jobPostingId,
  planId,
  onSuccess,
}: IUsePublishJobPostPayload) => {
  const { error, isError, isPending, mutate } = usePublishDraftJobPost();

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [error, isError]);

  const doPublish = useCallback(() => {
    if (!jobPostingId || !planId) {
      return;
    }

    mutate(
      { jobPostingId, planId },
      {
        onSuccess,
      },
    );
  }, [jobPostingId, planId, mutate, onSuccess]);

  return {
    isLoading: isPending,
    doPublish,
  };
};
